// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"5b3b6b2a","453":"adfced32","829":"c8d184e9","885":"6aa72417","931":"8d2269ad"}[chunkId] + ".chunk.js";
};